import { TranslatePipe } from '../../filters/translate.pipe';
import { ElementRef } from '@angular/core';
import { Component, OnInit, inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Popper from 'popper.js';
import AngularHelperService from '../../services/angular-helper.service';
import { Input } from '@angular/core';

@Component({
    standalone: true,
    selector: 'hr-employee-survey-popover',
    templateUrl: './hr-employee-survey-popover.component.html',
    imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export class HrEmployeeSurveyPopoverComponent implements OnInit, OnDestroy {
    private angularHelperService: AngularHelperService = inject(AngularHelperService);

    @Input() wrapper: any | undefined;
    @Input() placement: any | undefined;
    @Input() data: any | undefined;

    vm: any = undefined;
    watcher: any = undefined;

    constructor(private elementRef: ElementRef) {
        this.vm = this;
    }

    ngOnInit() {
        this.vm.placement = this.vm.placement || 'bottom';

        this.vm.element = this.angularHelperService.element(this.elementRef.nativeElement);
        this.vm.refElement = this.vm.element[0].querySelector('[data-ref]');
        this.vm.isOpen = false;

        var currentIsOpen = this.vm.isOpen;
        this.watcher = this.angularHelperService.createInterval(() => {
            var newIsOpen = this.vm.isOpen;
            if (currentIsOpen !== newIsOpen) {
                currentIsOpen = newIsOpen;
                this.handleIsOpenChange(newIsOpen);
            }
        }, 100);

        this.vm.handleRefButtonClick = this.handleRefButtonClick;
        this.vm.handleCloseButtonClick = this.handleCloseButtonClick;
        this.vm.redirect = this.redirect;
    }

    ngOnDestroy() {
        if (this.watcher) {
            this.angularHelperService.cancelInterval(this.watcher);
        }
    }

    handleRefButtonClick() {
        this.vm.isOpen = !this.vm.isOpen;
    }

    handleCloseButtonClick() {
        this.vm.isOpen = false;
    }

    redirect($event, link) {
        $event.preventDefault();
        window.location.href = link;
    }

    handleIsOpenChange(isOpen) {
        if (isOpen) {
            requestAnimationFrame(() => {
                var modifiers: any = { flip: { behavior: [this.vm.placement, this.vm.placementMobile] } };
                if (this.vm.popperWrapper) modifiers.preventOverflow = { boundariesElement: this.vm.popperWrapper };

                this.vm.popoverElement = this.vm.element[0].querySelector('.c-popover');
                this.vm.popper = new Popper(this.vm.refElement, this.vm.popoverElement, {
                    placement: this.vm.popperPlacement,
                    removeOnDestroy: true,
                    modifiers: modifiers,
                });

                requestAnimationFrame(() => { this.vm.popper.update(); });
            });
        }
    }

}